'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@achra/ui/accordion';
import { useMemo } from 'react';
import { CategoryItem } from './category-item';
import type { CategoryTree } from '../../types';
interface NonHeadcountSectionProps {
  categories: CategoryTree[];
  onValueChange: (newValue: string[]) => void;
}
function NonHeadcountSection(t0) {
  const $ = _c(16);
  const {
    categories,
    onValueChange
  } = t0;
  const mid = Math.ceil(categories.length / 2);
  let t1;
  if ($[0] !== categories || $[1] !== mid) {
    t1 = categories.slice(0, mid);
    $[0] = categories;
    $[1] = mid;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== categories || $[4] !== mid) {
    t2 = categories.slice(mid);
    $[3] = categories;
    $[4] = mid;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = [t1, t2];
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const columns = t3;
  let t4;
  if ($[9] !== categories) {
    t4 = categories.filter(_temp).map(_temp2);
    $[9] = categories;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const values = t4;
  if (categories.length === 0) {
    return null;
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="mb-3 border-b text-lg font-bold">Non-Headcount Expense Categories</h3>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== columns || $[13] !== onValueChange || $[14] !== values) {
    t6 = <div>{t5}<div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">{columns.map((columnCategories, columnIndex) => {
          const columnIds = columnCategories.map(_temp3);
          return <Accordion key={`column-${columnIds[0] ?? columnIndex}`} type="multiple" value={values} onValueChange={onValueChange}>{columnCategories.map(_temp4)}</Accordion>;
        })}</div></div>;
    $[12] = columns;
    $[13] = onValueChange;
    $[14] = values;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp4(category_1) {
  return <CategoryItem key={category_1.id} category={category_1} />;
}
function _temp3(cat) {
  return cat.id;
}
function _temp2(category_0) {
  return category_0.id;
}
function _temp(category) {
  return category.children.length > 0 && !category.isCollapsed;
}
export { NonHeadcountSection };